module.exports = __webpack_public_path__ + "static/media/logoText.78b46dc4.svg";